import styled from 'styled-components';

export const ScStepCard = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px 24px 24px 40px;
  gap: 8px;
  border-radius: 12px;
  background-color: ${({ theme }) => theme.grayDarkColor};
  margin-left: 48px;
  position: relative;
  line-height: 1.5;

  & > .title {
    font-weight: 700;
    font-size: 16px;
    letter-spacing: 0.01em;
  }

  & > .text {
    font-weight: 400;
    font-size: 16px;
    color: ${({ theme }) => theme.blackLightColor};
  }

  & > .step-image {
    position: absolute;
    left: -48px;
    top: 50%;
    transform: translateY(-50%);
  }
`;
